import { queryOptions } from '@tanstack/react-query';
import { client as qontoClient } from '#queries/utils';
import { persons as kycAcceptance } from '#proto/index.qonto.kycb.acceptance';
import type { KycResponse } from './types';

/** Query key factory for KYC acceptance queries. */
export const kycQueryKeys = {
  all: ['kyc-acceptance'] as const,
  /**
   * @param market - Optional market identifier appended to the key for cache isolation.
   */
  item: (market?: string) => [...kycQueryKeys.all, 'status', ...(market ? [market] : [])] as const,
};

export async function fetchKycAcceptance(market?: string): Promise<KycResponse> {
  const response = await qontoClient<KycResponse>(`/kycb-acceptance/v1/persons/me`, {
    method: 'GET',
    ...(market ? { params: { market } } : {}),
  });

  return kycAcceptance.firstparty.v1.ApiGetPersonAcceptanceResponse.fromJSON(response);
}

/** Query option factories for KYC acceptance data. */
export const kycQueries = {
  all: kycQueryKeys.all,
  /**
   * Builds query options for fetching the current user's KYC acceptance status.
   *
   * @param market - Optional market identifier (e.g. legal country). When provided,
   *   it is included in the query key for per-market cache isolation and forwarded
   *   as a `market` query parameter to `GET /kycb-acceptance/v1/persons/me`.
   */
  item: (market?: string) =>
    queryOptions({
      queryKey: kycQueryKeys.item(market),
      queryFn: () => fetchKycAcceptance(market),
    }),
};
